import React from "react";
import styled from "styled-components";
import { storeProducts } from "./../Data";
import Product from "./Product";

import { ProductConsumer } from "../Context/AddProWakel";
import Navbar from "../Navbar/Navbar";

class ProductList extends React.Component {
  constructor() {
    super();
    this.state = {
      products: storeProducts
    };
  }
  render() {
    return (
      <>
        <Navbar />
        <PageContainer>
          {/* <PageHeader>
            <h1 className="page-title">سەرەکی</h1>
            <p className="page-subtitle">هەڵبژاردنی بەشی پێویست</p>
          </PageHeader> */}
          <div className="py-5">
            <div className="container">
              <div className="row">
                <ProductConsumer>
                  {(value) => {
                    return value.products.map((product) => {
                      return <Product key={product.id} product={product} />;
                    });
                  }}
                </ProductConsumer>
              </div>
            </div>
          </div>
        </PageContainer>
      </>
    );
  }
}

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e272e 0%, #2C3539 50%, #34495e 100%);
  padding-bottom: 2rem;
`;

const PageHeader = styled.div`
  text-align: center;
  padding: 3rem 0 1rem;
  
  .page-title {
    color: #ffffff;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .page-subtitle {
    color: #a8b2b8;
    font-size: 1.1rem;
    font-weight: 400;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 0 1rem;
    
    .page-title {
      font-size: 2rem;
    }
    .page-subtitle {
      font-size: 1rem;
    }
  }
`;

export default ProductList;
